import FormattedMessage from 'I18n/components/FormattedMessage';
import SectionHeading from '../../../components/SectionHeading';
import FullWidthBackgroundColor from '../../../components/TrackLessonOverviewModal/subcomponents/FullWidthBackgroundColor';
import styled, { theme } from 'academy-common-lib/utils/Styling';
import { ModalTile, ModalTileSection } from '../../../components/TrackLessonOverviewModal/subcomponents/ModalTile';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DarkUITile = styled(ModalTile).withConfig({
  displayName: "OverviewModalCurriculumSection__DarkUITile",
  componentId: "sc-1oknswq-0"
})(["color:", ";margin-top:0 !important;background-color:transparent;"], theme.colors.OLAF);
export const OverviewModalCurriculumSection = ({
  children
}) => {
  return /*#__PURE__*/_jsxs(DarkUITile, {
    children: [/*#__PURE__*/_jsx(FullWidthBackgroundColor, {
      $color: "OBSIDIAN"
    }), /*#__PURE__*/_jsxs(ModalTileSection, {
      children: [/*#__PURE__*/_jsx(SectionHeading, {
        className: "m-bottom-4",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.overviewModal.curriculum"
        })
      }), children]
    })]
  });
};
export default OverviewModalCurriculumSection;